import { createFileRoute } from "@tanstack/react-router";
import { AccountCreditPage } from "@/features/office/account-credit";

export const Route = createFileRoute(
  "/office/billing/accounts/$accountId/wallet",
)({
  component: AccountCreditPage,
});
